<h1 mat-dialog-title>List Item</h1>
<mat-dialog-content>
  <div class="fields-container">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput type="text" [formControl]="listItemNameFormControl" [required]="true" floatLabel='never'>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput type="text" [formControl]="listItemDescriptionFormControl" [required]="true" floatLabel='never'>
    </mat-form-field>
    <mat-checkbox [formControl]="listItemActiveFormControl">Active</mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-action-buttons">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-button (click)="onSaveClick()">Save</button>
</mat-dialog-actions>

